export function collectReferences(text) {
    const re = /\$(?:`([^`]+)`|([A-Za-z_][A-Za-z0-9_]*))%[dsb](?:\[)?/g;
    const out = new Set();
    let m;
    while ((m = re.exec(text))) {
        out.add((m[1] ?? m[2] ?? "").trim());
    }
    return Array.from(out);
}
